import type { Session } from '@supabase/supabase-js'
import type { AuthUser } from '@/shared/domain'

export class AuthUserMapper {
  static toDomain(session: Session | null): AuthUser | null {
    if (!session || !session.user) {
      return null
    }
    const user = session.user
    return {
      id: user.id,
      email: user.email,
      fullName: user.user_metadata?.full_name ?? undefined,
      avatarUrl: user.user_metadata?.avatar_url ?? undefined,
    }
  }
}
